import Blue from "~/core";
import { createPopper } from '@popperjs/core';

new Blue({
	name: 'Copy Url',
	selector: ".copy",
	setup(copy) {
		const tooltip = document.querySelector('.tooltip');
		const textContent = copy.querySelector('span').textContent;

		const offsetFunction = ({ placement }) => {
			switch (placement) {
				case "top":
					return [0, 15];
				case "right":
					return [0, 15];
				case "left":
					return [15, 0];
				case "bottom":
					return [0, 15];
				default:
					return [0, 0];
			}
		};

		const popperInstance = createPopper(copy, tooltip, {
			placement: 'auto',
			modifiers: [
				{
					name: "offset",
					options: {
						offset: offsetFunction
					}
				}
			]
		});

		function show(e) {
			tooltip.setAttribute('data-show', '');
			popperInstance.update();
			if(e.target.classList.contains('copy-url')) {
				navigator.clipboard.writeText(window.location.href);
			} else {
				navigator.clipboard.writeText(textContent);
			}
		}

		function hide() {
			setTimeout(() => {
				tooltip.removeAttribute('data-show');
			}, 2000);
		}

        this.$addEvents(copy, 'click', show);
        this.$addEvents(copy, 'enter', show)
		this.$addEvents(copy, 'mouseout', hide);
	}
});